import { Drawer } from 'src/components/drawer';
import { useGetAllAssets, useGetProducts } from 'src/hooks';

import { AssetSelectionContent } from './AssetSelectionContent';
import type { ThemeAssetsSelectorDrawerProps } from './ThemeAssetsSelectorDrawer.interface';

export const ThemeAssetsSelectorDrawer = (
  props: ThemeAssetsSelectorDrawerProps,
) => {
  const { data: assets = [], refetch: refetchAssets } = useGetAllAssets();
  const { data: [product] = [] } = useGetProducts([
    `product_code=${props.productCode}`,
  ]);

  return (
    <Drawer open={props.open} onClose={props.onCloseModal}>
      {props.open && (
        <AssetSelectionContent
          assets={assets}
          product={product}
          props={props}
          refetchAssets={refetchAssets}
        />
      )}
    </Drawer>
  );
};
